import {
  ADDRESS_LIST_FAILED,
  ADDRESS_LIST_SUCCESS,
  ADDRESS_LIST_INVALID_REQUEST,
  ADDRESS_LIST_NOT_FOUND,
  LOADING_ADDRESS_LIST,
  RESET_ADDRESS_LIST,
  DELETE_ADDRESS_SUCCESS,
  DELIVERY_ADDRESS,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  address: {},
  deliveryAddress: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADDRESS_LIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        notFound: false,
      };

    case ADDRESS_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        notFound: false,
      };
    case ADDRESS_LIST_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        notFound: false,
      };

    case ADDRESS_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        notFound: false,
        address: action.payload,
      };

    case DELETE_ADDRESS_SUCCESS: {
      const { addrId } = action.payload;
      return {
        ...state,
        address: state.address.filter((d) => d.addrId !== addrId),
      };
    }

    case DELIVERY_ADDRESS: {
      return {
        ...state,
        deliveryAddress: action.payload,
      };
    }

    case ADDRESS_LIST_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: true,
      };

    case RESET_ADDRESS_LIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        notFound: false,
      };

    default:
      return state;
  }
};
